export type SocketData = string | ArrayBuffer | ArrayBufferView | Blob;

export type SendPolicy = 'queue' | 'drop' | 'error';

export const DEFAULT_SEND_QUEUE_MAX_SIZE = 100;

export class SendQueue {
  private items: SocketData[] = [];
  private maxSize: number;

  constructor(
    maxSize: number = DEFAULT_SEND_QUEUE_MAX_SIZE,
    private onOverflow?: (dropped: SocketData) => void,
  ) {
    this.maxSize = maxSize;
  }

  public get depth(): number {
    return this.items.length;
  }

  public enqueue = (data: SocketData): void => {
    if (this.items.length >= this.maxSize) {
      const dropped = this.items.shift();
      if (dropped !== undefined) {
        this.onOverflow?.(dropped);
      }
    }
    this.items.push(data);
  };

  public drain = (): SocketData[] => {
    const out = this.items;
    this.items = [];
    return out;
  };

  public clear = (): void => {
    this.items = [];
  };
}
